/**
 * Focus industries and geography - positioning only, no pricing math.
 */

export const marketsContent = {
  intro:
    "We tailor AI workflows, disciplined Wi‑Fi, and fast launches for teams that operate in physical spaces, omnichannel commerce, regulated advice, warehouses, classrooms, or mixed-use footprints across Southern California.",

  disclaimer:
    "Vertical notes describe typical fit - not guarantees about regulatory compliance or vendor certifications. Obtain advice from counsel for regulated industries.",

  industries: [
    {
      id: "hospitality",
      name: "Hospitality",
      segments: "Hotels, restaurants, nightlife, event venues",
      bullets: [
        "Guest-net segmentation away from POS and back-office VLANs",
        "Overflow voice and concierge-style chat wired to bookings or upsells",
        "After-hours coverage without burning out front-desk rotations",
      ],
    },
    {
      id: "retail",
      name: "Retail",
      segments: "E-commerce storefronts plus brick-and-mortar",
      bullets: [
        "Inventory-grounded FAQs and staff lookup assistants with guardrails",
        "Separate wireless traffic for scanners, shopper Wi‑Fi, and payment islands",
        "Launch-ready marketing sites synced with fulfillment expectations",
      ],
    },
    {
      id: "professional-services",
      name: "Professional services",
      segments: "Accounting, consulting, finance boutiques",
      bullets: [
        "Document-grounded responses with explicit escalation to licensed humans",
        "Private chat consoles for engagements - never dumping raw spreadsheets into public widgets",
      ],
      caveat:
        "We do not provide legal, tax, securities, or insurance advice - and we engineer prompts and access control to reflect that separation.",
    },
    {
      id: "manufacturing",
      name: "Manufacturing & distribution",
      segments: "Industrial plants, fulfillment, distribution centers",
      bullets: [
        "Handheld and fixed reader coverage tuning for aisles mezzanines, and coolers",
        "Guest or contractor VLANs isolated from PLC or business traffic",
      ],
    },
    {
      id: "education",
      name: "Education",
      segments: "Private schools, training centers, enrichment programs",
      bullets: [
        "Family FAQs, enrollment flows, registrar-friendly chat escalation",
        "Network segmentation for learner devices versus administration",
      ],
      caveat:
        "Student data requires counsel-reviewed policies (e.g., FERPA/COPPA). We integrate only after approvals are documented.",
    },
  ],

  geography: [
    {
      slug: "la",
      region: "Los Angeles County",
      note: "Dense competition and premium budgets - we bring crisp discovery and phased delivery cadences.",
    },
    {
      slug: "orange",
      region: "Orange County",
      note: "Hybrid corporate and lifestyle brands - heavy emphasis on uptime and concierge-grade UX.",
    },
    {
      slug: "sandiego",
      region: "San Diego",
      note: "Defense-adjacent, biotech, and tourism footprints lean on audited change windows and failover voice.",
    },
    {
      slug: "ie",
      region: "Inland Empire",
      note: "Logistics-heavy environments where RF coverage audits and forklift lanes matter.",
    },
    {
      slug: "riverside-sb",
      region: "Riverside / San Bernardino",
      note: "Emerging corridors where standardized playbooks shorten time-to-stable networks and AI assistants.",
    },
  ],
};
